import type { AbstractAdaptor, AnalyticsParams } from '@/services/analytics/adaptors/abstract';

declare function gtag(command: string, name: any, params?: any): void;

/**
 * Google Tah Manager
 * The script has to be initialized in the index page
 * I tried to manually load the script here, but it did not work for some reason
 */
export class GoogleAdaptor implements AbstractAdaptor {
  trackingId: string;

  init(options: { trackingId: string }) {
    this.trackingId = options.trackingId;

    if (typeof window === 'undefined' || typeof gtag !== 'function') return;

    gtag('config', this.trackingId, { send_page_view: true });
  }

  send(name: string, params?: AnalyticsParams) {
    if (typeof window === 'undefined' || typeof gtag !== 'function') return;

    // gtag('event', '<event_name>', {<event_params>});
    gtag('event', name, params);
  }
}
